module.exports = __webpack_public_path__ + "static/media/brands.3e916ca5.png";